import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";

// Route-level code splitting with React.lazy
const Service = lazy(() => import("./Service"));
const About = lazy(() => import("./About"));
const MainPage = lazy(() => import("./Mainpage"));
const Contact = lazy(() => import("./Contact"));
const Enquiry = lazy(() => import("./Enquiry"));
const Client1 = lazy(() => import("./Client1"));

const ServiceDetail = lazy(() => import("./ServiceDetail"));
const Reviews = lazy(() => import("./Reviews"));

function PageLoader() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        width: "100%",
      }}
      role="status"
      aria-label="Loading page"
    >
      <CircularProgress sx={{ color: "#002B6B" }} />
    </Box>
  );
}

function Subpage() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Box sx={{ pt: { xs: "70px", sm: "80px", md: "85px", lg: "95px" } }}>
        <Routes>
          <Route path="/" element={<Navigate to="/home" replace />} />
          <Route path="/home" element={<MainPage />} />
          <Route path="/service" element={<Service />} />
          <Route path="/service/:category" element={<ServiceDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/enquiry" element={<Enquiry />} />
          <Route path="/client1" element={<Client1 />} />
          <Route path="/reviews" element={<Reviews />} />
        </Routes>
      </Box>
    </Suspense>
  );
}

export default Subpage;
